module.exports = __webpack_public_path__ + "img/thumbnail_IndianPeafowl_m_albino.4865946e.png";